<template>
    <div>
        <p>Hello!</p>
        <p>Please click on a link on the left navbar for data.</p>
    </div>
</template>